// `extract.brand`: a brand read from its website (#249). The brand form's
// "Import from Website" starts it and fills from its answer; live lists no such job, and
// a Studio draft never holds one.
import { ExtractBrandQuote, ExtractBrandRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"extract.brand"> = {
  type: "extract.brand",
  label: "Brand from a website",
  source: "form",
  pair: "extract.brand",
  fields: () => ({}),
  request: ExtractBrandRequest,
  quote: ExtractBrandQuote,
};
